import API from "@/api";

export default {
  namespaced: true,

  state: {},

  actions: {
    async create({ dispatch }, payload) {
      try {
        await API.Legals.create(payload);
      } catch (e) {
        throw e;
      }
    }
  },

  mutations: {},

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/legals.js